/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC, useEffect, useState} from 'react'
import {AnimaFadeinTop} from '../../../../_metronic/assets/animation/styles'
import {ConditioningWrapper} from './pages/dashboard/ConditioningWrapper'
import {useIntl} from 'react-intl'
import {PageTitle} from '../../../../_metronic/layout/core'
import {ConditioningListWrapper} from './components/conditionnig-list/ConditioningList'
import {QueryRequestProvider} from './components/conditionnig-list/core/QueryRequestProvider'
import {QueryResponseProvider} from './components/conditionnig-list/core/QueryResponseProvider'
import {ListViewProvider} from './components/conditionnig-list/core/ListViewProvider'
import {KTCard} from '../../../../_metronic/helpers'
import {ConditioningsListHeader} from './components/conditionnig-list/components/header/ConditioningsListHeader'
import {useParams} from 'react-router-dom'
import {ConditioningNewWrapper} from './pages/dashboard/ConditioningNewWrapper'

const ConditioningPage: FC = () => {
  const intl = useIntl()
  const {tab} = useParams()
  const [cssTab1, setCssTab1] = useState('active')
  const [cssTabDiv1, setCssTabDiv1] = useState('active show')
  const [cssTab2, setCssTab2] = useState('')
  const [cssTabDiv2, setCssTabDiv2] = useState('')

  useEffect(() => {
    handleTab(tab)
    // eslint-disable-next-line
  }, [])

  // FUNCÃO PARA TRATAR A TAB ATIVA
  function handleTab(tabI: any) {
    let tab = parseInt(tabI)
    if (tab === 1) {
      setCssTab1('active')
      setCssTab2('')
      setCssTabDiv1('active show')
      setCssTabDiv2('')
    } else if (tab === 2) {
      setCssTab1('')
      setCssTab2('active')
      setCssTabDiv1('')
      setCssTabDiv2('active show')
    }
  }

  return (
    <>
      <PageTitle breadcrumbs={[]}>{intl.formatMessage({id: 'MENU.CONDITIONING'})}</PageTitle>
      <AnimaFadeinTop>
        <div className='card mb-3'>
          <div className='card-header justify-content-start d-flex align-items-center'>
            <ul className='nav'>
              <li className='nav-item me-5 '>
                <a
                  className={`btn btn-text-gray-600 btn-active-light-primary fs-8 ${cssTab1}`}
                  data-bs-toggle='tab'
                  href='#kt_tab_pane_1'
                >
                  {intl.formatMessage({id: 'MENU.DASHBOARD'})}
                </a>
              </li>
              <li className='nav-item me-5'>
                <a
                  className={`btn btn-text-gray-600 btn-active-light-primary fs-8 ${cssTab2}`}
                  data-bs-toggle='tab'
                  href='#kt_tab_pane_2'
                >
                  {intl.formatMessage({id: 'CONDITIONINGS.TITLE_LIST'})}
                </a>
              </li>
            </ul>
          </div>
        </div>
        <QueryRequestProvider>
          <QueryResponseProvider>
            <ListViewProvider>
              <div className='tab-content' id='myTabContent'>
                <div className={`tab-pane fade ${cssTabDiv1}`} id='kt_tab_pane_1' role='tabpanel'>
                  <ConditioningNewWrapper />
                </div>
                <div className={`tab-pane fade ${cssTabDiv2}`} id='kt_tab_pane_2' role='tabpanel'>
                  <ConditioningListWrapper />
                </div>
              </div>
            </ListViewProvider>
          </QueryResponseProvider>
        </QueryRequestProvider>
      </AnimaFadeinTop>
    </>
  )
}

export {ConditioningPage}
